import dotenv from 'dotenv';
dotenv.config();

export default {
  methods: {
    isMobile() {
      if (process.env.VUE_APP_ENV === 'DEV') {
        return true;
      }
      return /Mobile|mini|Fennec|Android|iP(ad|od|hone)/i.test(navigator.userAgent);
    }
  }
} 
